export const environment = {
  production: true,
  env_name: 'PROD'
};
